<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1">
      <!-- MainView -->
      <article class="wrapper wrapper-content main-column full-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
                <img src="static/img/assets/nav_okr_on.png" alt="">
                {{ $t('termsServiceTitle') }}
            </h1>
        </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight flex-option">
          <div class="ibox" v-if="isLicenseAgreement">
            <web-view-license-agreement-ja v-if="checkLanguage === 'ja'"/>
            <web-view-license-agreement-en v-if="checkLanguage === 'en'"/>
            <web-view-license-agreement-zh v-if="checkLanguage === 'zh'"/>
          </div>
          <div class="ibox" v-else>
            <!-- <web-view-terms /> -->
            <web-view-terms-ja v-if="checkLanguage === 'ja'"/>
            <web-view-terms-en v-else-if="checkLanguage === 'en'" />
            <web-view-terms-zh v-else-if="checkLanguage === 'zh_tr'" />
          </div>
      </section>
    </article>
    </div>
  </div>
</template>

<script>
import { i18n, licenseAgreement } from '@/main'
// import WebViewTerms from '@/views/_webview/WebViewTerms'
import WebViewTermsJa from '@/views/_webview/WebViewTermsJA'
import WebViewTermsEn from '@/views/_webview/WebViewTermsEN'
import WebViewTermsZh from '@/views/_webview/WebViewTermsZH'
import WebViewLicenseAgreementJa from '@/views/_webview/WebViewLicenseAgreementJa'
import WebViewLicenseAgreementEn from '@/views/_webview/WebViewLicenseAgreementEn'
import WebViewLicenseAgreementZh from '@/views/_webview/WebViewLicenseAgreementZh'
export default {
  name: 'Terms',
  components: {
    WebViewTermsJa,
    WebViewTermsEn,
    WebViewTermsZh,
    WebViewLicenseAgreementJa,
    WebViewLicenseAgreementEn,
    WebViewLicenseAgreementZh
  },
  data: function () {
    return {
    }
  },
  computed: {
    checkLanguage () {
      return i18n.locale
    },
    isLicenseAgreement: function () {
      return licenseAgreement
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .flex-option{
    display: flex;
    flex-direction: column-reverse;
  }
  section div{
    height: 100%;
    padding: 0.8em 1em 5em;
    overflow: visible;
  }
 section div >>> .app { overflow: visible; }
  .main-column {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/webview/Terms.vue